<template>
  <div class="hello" :style="webSize">
    <Row v-for="(item,index) in userConfig.screenRow" :key="index" :style="rowSize" type="flex" justify="center" align="top">
      <div  v-for="col in userConfig.screenColumn" :key="col" :style="setStyle(index+1,col).isStyle">
        <component v-if=" setStyle(index+1,col).isShow" :is="userConfig.screenShow[`${index+1}-${col}`].unitName" :unitSize="setStyle(index+1,col).sizeData"></component>
        <div v-else style="width: 100%;height: 100%"><img style="width: 100%;height: 100%" src="../assets/jiaolong.jpg"> </div>
      </div>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'ScreenSet',
  data () {
    return {
      webSize: {
        width: '0px',
        height: '0px'
      },
      rowSize: {
        height: 'auto'
      },
      colSize: {
        isStyle: {
          height: '100%',
          width: '',
          display: 'inline-block'
        },
        isShow: false,
        sizeData: {width: 1, height: 1}
      }
    }
  },
  computed: {
    setStyle () {
      return function (row, col) {
        let tempStyle = JSON.parse(JSON.stringify(this.colSize))
        let screenShow = this.userConfig.screenShow
        for (let unit in screenShow) {
          if (row === parseInt(unit.split('-')[0]) && col === parseInt(unit.split('-')[1])) {
            tempStyle.isStyle['z-index'] = '2'
            tempStyle['isShow'] = true
            tempStyle['sizeData'] = {'width': screenShow[unit].unitWidth + '00%', 'height': screenShow[unit].unitHeight + '00%'}
            return tempStyle
          }
        }
        return tempStyle
      }
    }
  },
  methods: {
  },
  created () {
    this.webSize.width = this.userConfig.screenWidth
    this.webSize.height = this.userConfig.screenHeight
    this.rowSize.height = 100 / this.userConfig.screenRow + '%'
    this.colSize.isStyle.width = 100 / this.userConfig.screenColumn + '%'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/lib/ScreenSet.vue